module.exports = __webpack_public_path__ + "static/media/corkboard-web.85c791aa.png";